<style scoped>
.modal.oppay .pin-code {
    display: flex;
}

.pin-code input {
    border-radius: 0px !important;
    border: solid #ced4da 0.8px;
    flex-grow: 1;
    border-right: transparent;
}

.pin-code input:first-child {
    border-radius: 4px 0px 0px 4px !important;
}

.pin-code input:last-child {
    border-right: solid #ced4da 0.8px !important;
    border-radius: 0px 4px 4px 0px !important;
}

/*  This handles for hardcoded hover button */
.pin-code input:nth-last-of-type(3):focus,
.pin-code input:nth-last-of-type(2):focus,
.pin-code input:first-child:focus,
.pin-code input:last-child:focus {
    border: solid #3eccf1 1.5px;
}

.modal.oppay input {
    border-radius: 0px;
    text-align: center;
    font-size: 20px;
}

.modal.oppay .form-control.no-label {
    font-size: 25px !important;
    padding: 10px;
}
</style>
<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-3 px-4">

    <div v-if="loading">
        <div class="my-3 animate slideInTop" style="background:url(/loading-black.svg) no-repeat center center;height:50px;"></div>
        <p>Please wait while your transaction is processing...</p>
    </div>

    <div v-else>
        <p>Please enter your 4-digit card pin to authorize this payment</p>

        <div class="modal-body pb-1">
            <div class="row m-0">
                <div class="col-12 px-0">
                    <div class="form-group text-center">
                        <div class="pin-code">
                            <input type="password" class="form-control no-label focus" v-model="card_pin1" ref="card_pin_input1" id="card_pin_input1" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required autofocus @focus="isFocus = true" @blur="isFocus = false" :style="{ border: (isFocus ? isFocusColor : '')  }" />
                            
                            <input type="password" class="form-control no-label focus" v-model="card_pin2" ref="card_pin_input2" id="card_pin_input2" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus2 = true" @blur="isFocus2 = false" :style="{ border: (isFocus2 ? isFocus2Color : '') , borderColorRight : (isFocus2 ? 'solid' + appColor : '')  }" />

                            <input type="password" class="form-control no-label focus" v-model="card_pin3" ref="card_pin_input3" id="card_pin_input3" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus3 = true" @blur="isFocus3 = false" :style="{ border: (isFocus3 ? isFocus3Color : '')  }" />

                            <input type="password" class="form-control no-label focus" v-model="card_pin4" ref="card_pin_input4" id="card_pin_input4" maxlength="1" placeholder="-" autocomplete="off" pattern="[0-9]{1}" required @focus="isFocus4 = true" @blur="isFocus4 = false" :style="{ border: (isFocus4 ? isFocus4Color : '')  }" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row m-0">
                <div class="col-12 px-0 mb-0">
                    <div class="form-group mb-0 text-center">
                        <a href="javascript:void(0)" class="text-tiny" @click.prevent="goBack"> &larr; Go back</a>
                    </div>
                    <div class="form-group text-center mb-0 mt-4">
                        <button type="button" class="btn app-bg-color" :style="{ background : appColor }" @click.prevent="submitDetails" ref="btnActionPay" id="btnActionPay"> Pay <span>{{ amount | currency('₦') }}</span> </button>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

export default {
    name: 'Pin',
    props: ['appColor'],
    watch: {
        isFocus(newVal) {
            if (newVal)
                this.isFocusColor = 'solid 1px ' + this.appColor;
        },
        isFocus2(newVal) {
            if (newVal)
                this.isFocus2Color = 'solid 1px ' + this.appColor;
        },
        isFocus3(newVal) {
            if (newVal)
                this.isFocus3Color = 'solid 1px ' + this.appColor;
        },
        isFocus4(newVal) {
            if (newVal)
                this.isFocus4Color = 'solid 1px ' + this.appColor;
        },
        /* card_pin(newVal){
            console.log(newVal)
            if(newVal.length == 4)
                this.disabled = false;

            console.log(this.disabled)
        }, */
        card_pin1: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.card_pin += this.card_pin1;
                    this.$refs.card_pin_input2.focus()
                }
            },
            deep: true
        },
        card_pin2: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.card_pin += this.card_pin2;
                    this.$refs.card_pin_input3.focus()
                }
            },
            deep: true
        },
        card_pin3: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.card_pin += this.card_pin3;
                    this.$refs.card_pin_input4.focus()
                }
            },
            deep: true
        },
        card_pin4: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.card_pin += this.card_pin4;
                    this.$refs.card_pin_input4.blur()
                }
            },
            deep: true
        }
    },
    created() {
        this.amount = this.$store.state.payload.transaction.amount / 100
    },
    mounted() {
        this.isFocusColor = 'solid 1px ' + this.appColor;
        this.$refs.card_pin_input1.focus();
    },
    data() {
        return {
            card_pin: '',
            card_pin1: '',
            card_pin2: '',
            card_pin3: '',
            card_pin4: '',
            isFocus: true,
            isFocus2: false,
            isFocus3: false,
            isFocus4: false,
            isFocusColor: '',
            isFocus2Color: '',
            isFocus3Color: '',
            isFocus4Color: '',
            // disabled: true,
            payText: '',
            amount: 0,
            loading: false,
            errors: {
                card_pin: false,
            }
        }
    },
    methods: {
        goBack() {
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },
        submitDetails() {
            // this.card_pin = this.card_pin1+this.card_pin2+this.card_pin3+this.card_pin4
            if (this.card_pin.length < 4)
                return;

            this.loading = true;
            let vm = this;
            var payload = {
                pan: this.$store.state.card_cc,
                expdate: this.$store.state.card_exp,
                cvv: this.$store.state.card_cvv,
                pin: this.card_pin,
                transRef: this.$store.state.transRef,
            };

            if (this.$store.state.isFailed)
                payload.parentTransRef = this.$store.state.parentTransRef

            // Append Transaction Ref into transaction_desc
            // Eg. 23489490AB_Payment for airtime purchase
            if(Object.keys(payload.transaction).includes('transaction_desc'))
                payload.transaction.transaction_desc = `${payload.transaction.transaction_ref}_${payload.transaction.transaction_desc}`;

            setTimeout(() => {
                axios.post(vm.baseApiUrl + "v1/charge", {
                        data: vm.$generateToken(payload)
                    }, {
                        Authorization: 'bearer ' + vm.$store.state.payload.api_key
                    })
                    .then(response => {
                        var res = response.data;
                        if (response.status === 200) {
                            window.raw = JSON.stringify(res.data);
                            
                            if (res.code == "00") {
                                this.loading = false;
                                
                                // Check if user set close_popup for card to onSuccess
                                let payload = vm.$store.state.payload
                                if(payload.options && payload.options.close_popup && payload.options.close_popup.card == 'onSuccess'){
                                    let onepipeResponse = res.data
                                    delete onepipeResponse.data.client_info;
                                    delete onepipeResponse.data.paymentoptions;
                                    delete onepipeResponse.data.message;
                                    delete onepipeResponse.data.status;
                                    vm.$parent.continueToMerchant({
                                        message: onepipeResponse.message,
                                        status: onepipeResponse.status,
                                        data: onepipeResponse.data,
                                    });
                                    return;
                                }
                                
                                vm.$parent.changeComponent('Status', {
                                    reference: payload.transRef,
                                    type: 'Successful',
                                    message: res.message || res.data.message
                                });
                            } else if (res.code == "10") {
                                vm.$parent.changeComponent('OTP', {
                                    msg: res.message,
                                });
                            } else if (res.code == "99") {
                                vm.$parent.changeComponent('Status', {
                                    message: res.message || res.data.message,
                                    failedFromStart: false,
                                    raw: JSON.stringify(res.data),
                                    type: 'warning'
                                });
                            } else if (res.code == "01") {
                                window.failedFromStartMessage = res.message
                                window.failedFromStart = false;
                                vm.$router.push('warning');
                            } else if (res.code == null) {
                                window.failedFromStart = false;
                                window.failedFromStartMessage = "An error occured from the main server, please try again or contact the webmaster hussien@onepipe.io."
                                vm.$router.push('warning');
                            } else {
                                window.failedFromStartMessage = res.message || res.data.message
                                window.failedFromStart = false;
                                vm.$router.push('warning');
                            }
                        } else {
                            window.failedFromStartMessage = res.message;
                            window.failedFromStart = false;
                            window.raw = JSON.stringify(res.data);
                            vm.$router.push('warning');
                        }

                        vm.$parent.changeComponent('OTP');
                        vm.loading = false;
                    })
                    .catch(error => {
                        window.raw = JSON.stringify(error);
                        window.failedFromStart = false;
                        window.failedFromStartMessage = error;
                        vm.$router.push('warning');
                    })
            }, 300);

        }
    }

}
</script>
